import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=2a2a8028"
import script from "./ProgressBar.vue?vue&type=script&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a2a8028')) {
      api.createRecord('2a2a8028', component.options)
    } else {
      api.reload('2a2a8028', component.options)
    }
    module.hot.accept("./ProgressBar.vue?vue&type=template&id=2a2a8028", function () {
      api.rerender('2a2a8028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/ProgressBar.vue"
export default component.exports